export function agentMemoriesKey(organizationId: string | undefined) {
  return ['agent-memories', organizationId] as const;
}

export function agentThreadsKey(organizationId: string | undefined) {
  return ['agent-threads', organizationId] as const;
}
